import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";

import s from "./CollapsibleItem.scss";

import Icon from "../../Icon/Icon";

class CollapsibleItem extends Component {
  state = {
    isExpanded: false
  };

  handleToggle = () => {
    const { isExpanded } = this.state;

    this.setState({
      isExpanded: !isExpanded
    });
  };

  render() {
    const { label, children } = this.props;
    const { isExpanded } = this.state;

    return (
      <li className="CollapsibleItem">
        <button
          className="CollapsibleItem__header"
          type="button"
          onClick={this.handleToggle}
        >
          <span>{label}</span>
          <div className="CollapsibleItem__iconContainer">
            <Icon icon={isExpanded ? "chevronUp" : "chevronDown"} />
          </div>
        </button>

        {isExpanded && <div className="CollapsibleItem__body">{children}</div>}
      </li>
    );
  }
}

CollapsibleItem.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node
};

CollapsibleItem.defaultProps = {
  children: null
};

export default withStyles(s)(CollapsibleItem);



// WEBPACK FOOTER //
// ./src/components/Search/CollapsibleItem/CollapsibleItem.js